// dropdown-filter.component.ts
import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MultiSelectItem } from '../multi-select-control/multi-select-control.component';

import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
export interface DropdownItem<TKey = string, TSource = any> {
  key?: TKey;
  value?: string;
  disabled?: boolean;
  source?: TSource;
}

@Component({
    selector: 'app-dropdown-control',
    templateUrl: './dropdown-control.component.html',
    styleUrl: './dropdown-control.component.scss',
    imports: [FormsModule, CommonModule]
})
export class DropdownControlComponent implements OnInit {
  @ViewChild('dropdownContainer') dropdownContainer!: ElementRef;
  @ViewChild('dropdownMenu') dropdownMenu!: ElementRef;

  @Input() items: DropdownItem<any>[] = [];
  @Input() selectedKey?: any;
  @Input() disabled = false;
  @Input() placeholder = 'Select an item';

  @Input("isInvalid") _invalid?: boolean = false;
  @Input("invalidFeedback") _invalidFeedback?: string = '';
  @Input() required?: boolean | 'true' | 'false' | '' | string = false;

  get isRequired() { return this.required === true || (typeof this.required === 'string' && this.required !== 'false') }
  get isInvalid() { return this._invalid || this.isRequired && !this.selectedKey; }
  get invalidFeedback() { return this._invalidFeedback || ((typeof this.required === 'string' ? this.required : '') || 'Value is required') }
  

  @Output() selectionChange = new EventEmitter<DropdownItem | null>();
  @Output() selectedKeyChange = new EventEmitter<string | null>();

  filteredItems: DropdownItem[] = [];
  filterText = '';
  isOpen = false;

  get displayText(): string {
    if (!this.selectedKey) return this.placeholder;
    const selected = this.items.find(item => item.key === this.selectedKey);
    return selected ? selected.value! : this.placeholder;
  }

  ngOnInit() {
    this.items = this.items || [];
    this.filteredItems = [...this.items];
  }

  toggleDropdown() {
    if (this.disabled) return;
    this.isOpen = !this.isOpen;
    if (this.isOpen) this.filterItems(); // Refresh filter when opening
  }

  filterItems() {
    if (!this.filterText) {
      this.filteredItems = [...this.items];
    } else {
      const searchText = this.filterText.toLowerCase();
      this.filteredItems = this.items.filter(item =>
        item.value!.toLowerCase().includes(searchText) ||
        item.key.toLowerCase().includes(searchText)
      );
    }
  }

  clearFilter() {
    this.filterText = '';
    this.filterItems();
    //this.selectionChange.emit(null); // Emit null when selection is cleared
  }

  isSelected(item: DropdownItem): boolean {
    return item.key === this.selectedKey;
  }

  selectItem(item: DropdownItem, event: Event) {
    event.preventDefault();
    if (item.disabled) return;

    this.selectedKey = item.key;
    this.isOpen = false;
    this.selectionChange.emit(item); // Emit the selected item
    this.selectedKeyChange.emit(item.key);
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (!this.dropdownContainer?.nativeElement?.contains(event.target)) {
      this.isOpen = false;
    }
  }
}
